import { Avatar, Stack } from '@chakra-ui/react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

import React from 'react';
import { useAppSelector } from '../../../hooks';

// const { REACT_APP_GOOGLE_API } = process.env;

const MapView = () => {

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyCsvDO2ZMssvwhcmIo2TqXvJSL0zlMD5bw'
    });

    //eslint-disable-next-line
    const [map, setMap] = React.useState<null | any>(null);

    const { company } = useAppSelector(state => state.companyReducer);

    const { lat, long } = company;

    const parentWidth = document.getElementById('mapview-container')?.offsetWidth || 0;

    const containerStyle = {
        width: parentWidth,
        height: '400px'
    };
    
    const center = {
        lat: lat || -26.20227,
        lng: long || 28.04363
    };

    const onLoad = React.useCallback(function callback(map: any) {
        const bounds = new window.google.maps.LatLngBounds(center);
        map.fitBounds(bounds);
        setMap(map);
    }, []);

    //eslint-disable-next-line
    const onUnmount = React.useCallback(function callback(map: any) {
        setMap(null);
    }, []);

    return (
        <Stack id='mapview-container'>
            {
                isLoaded &&
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={15}
                    onLoad={onLoad}
                    onUnmount={onUnmount}
                >
                    { /* Child components, such as markers, info windows, etc. */}
                    <Marker
                        icon={
                            `${<Avatar size='2xs' name='Dan Abrahmov' src='https://bit.ly/dan-abramov' />}`
                        }
                        position={center}
                    />
                </GoogleMap>
            }
        </Stack>
    );
};

export default React.memo(MapView);